module.exports = __webpack_public_path__ + "static/media/trash.ee46ca53.svg";